import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import css from './PhotoUpload.scss';
import StyledButton from 'common/StyledButton';
import Header from 'common/Header';
import Icon from 'SF/MaterialIcon';
import { isEmptyString } from 'utils/text';
import { upload } from 'utils/request';
import classnames from 'classnames';

/**
 * @returns {node} the modal used to upload a new profile photo.
 */
const PhotoUpload = ({ isIE, isOpen, onClose, onUpload, photoAcceptTypes, validatePhoto }) => {
    const [photo, setPhoto] = useState(null);
    const [error, setError] = useState(null);
    
    Modal.setAppElement(document.getElementById('main-center'));
    
    const getPhotoText = () => {
        if (!photo) return 'No image chosen...';
        return photo.name;
    };

    const close = () => {
        onClose();
        setPhoto(null);
        setError(null);
    };
    
    const handleSave = (status) => {
        if (status !== 200) return setError("We could not upload your photo at this time");
        onUpload();
        close();
    };
    
    const save = async () => {
        const { isValid, reasonInvalid } = validatePhoto([photo]);
        if (!isValid) {
            setError(reasonInvalid);
            return;
        }
        
        const formData = new FormData();
        formData.append('photo', photo);
        
        await upload('../instructor/uploadPhoto.html', {
            method: 'POST',
            body: formData
        }).then(sentReq => handleSave(sentReq.status));
    };
    
    return (
        <Modal isOpen={isOpen}
               className={css['modal']}
               onAfterOpen={() => { document.getElementById('profilePhotoUpload').focus(); }}
               onRequestClose={close} 
               overlayClassName={css['overlay']}>
            <Header closeModal={close} />
            <div className={classnames(css.content, { [css.error]: !isEmptyString(error) })}>
                <h1 className={css['header']}>Upload Profile Photo</h1>
                <div className={css['description']}>We accept jpg, jpeg, png files.</div>
                <input className={css['upload-input']}
                       id="profilePhotoUpload"
                       type="file"
                       aria-label="Browse for profile photo"
                       onChange={(e) => setPhoto(e.target.files[0]) }
                       accept={photoAcceptTypes} />
                <div className={css['upload-input-label']}>
                    <div className={classnames(css['upload-photo-name'], { [css.ie]: isIE })}>
                        <span>{getPhotoText()}</span>
                    </div>
                    <label tabIndex="0" aria-hidden={true} htmlFor="profilePhotoUpload">
                        <Icon icon="add_a_photo" className={css['upload-photo-icon']} />Browse
                    </label>
                </div>
                <span className={css['error-description']}>{error}</span>
            </div>
            <div className={css['actions']}>
                <StyledButton disabled={photo === null}
                              onClick={save}>
                    Upload Now
                </StyledButton>
            </div>
        </Modal>
    )
};

PhotoUpload.propTypes = {
    isIE: PropTypes.bool,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
    photoAcceptTypes: PropTypes.string,
    validatePhoto: PropTypes.func.isRequired
};

export default PhotoUpload;
